<template>
  <div class="container container_40 verification__approved-banner banner">
    <md-icon class="md-size-3x">check</md-icon>

    <div>
      <div class="banner__title text_x_large" v-html="i18n.kyc_approved_title({ account_type: userType === userTypes.syndicate
              ? i18n.kyc_corporate() : i18n.kyc_general() })">

      </div>
      <p class="banner__description text_large">{{ i18n.kyc_approved_msg() }}</p>
    </div>
    <div class="btn-wrap margin-top">
      <md-button class="btn md-primary" @click="updateKYC()">{{ i18n.kyc_update() }}</md-button>
    </div>
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'
  import { userTypes } from '@const'

  export default {
    name: 'VerificationApprovedBanner',
    data: _ => ({
      i18n,
      userTypes
    }),
    props: ['userType'],
    methods: {
      updateKYC () {
        this.$parent.handleUpdate(this.userType)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './verification.scss';

</style>



// WEBPACK FOOTER //
// src/vue/app/verification/make/Verification.ApprovedBanner.vue